import { render, staticRenderFns } from "./ArtistAbout.vue?vue&type=template&id=6ec5b90a&"
import script from "./ArtistAbout.vue?vue&type=script&lang=js&"
export * from "./ArtistAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports